<template>
  <div>
    <div class="template-detail-card">
      <div class="row">
        <div class="col-12 d-block d-sm-flex justify-content-between">
          <div class="d-block d-sm-flex align-items-center">
            <span class="text-semibold-black font-size-16">
              {{ templateDetail.templateName }}
            </span>
            <div class="d-flex mt-1 mt-sm-0">
              <b-badge
                pill
                :variant="badgeVariant(templateDetail.status)"
                class="ml-0 ml-sm-1 font-9px"
                >{{ badgeStatus(templateDetail.status) }}
              </b-badge>
              <span
                @click="goToTemplateHistory"
                class="menu-link ml-1 d-none d-sm-flex"
              >
                Escalation Events
              </span>
              <span
                @click="goToTemplateHistory"
                class="menu-link ml-1 d-flex d-sm-none"
              >
                History
              </span>
            </div>
          </div>
          <div class="pr-2 mt-1 mt-sm-0">
            <atom-button
              v-if="hasUpdateTicketEscalationPermission"
              buttonId="edit-template-button"
              @click="clickEditTemplate(templateDetail.templateId)"
            >
              <span>Edit</span>
            </atom-button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="card-description mt-2 mt-md-1 pr-2 pr-lg-0">
            <p>{{ templateDetail.description }}</p>
          </div>
          <div class="inner-card d-flex mt-1 pr-2 pr-lg-0">
            <div class="inner-card-style">
              <div class="icon-wrapper icon-bg-in-progress">
                <feather-icon
                  size="24"
                  icon="TagIcon"
                  class="custom-icon-position"
                  stroke="#7367F0"
                />
              </div>
              <div class="apply-amount-wrapper">
                <span class="text-semibold-black font-size-24">
                  {{ templateDetail.applyAmount.inProgress }}
                </span>
                <span
                  v-if="
                    templateDetail.applyAmount.inProgress &&
                    Number(templateDetail.applyAmount.inProgress) > 0
                  "
                  class="dot"
                ></span>
              </div>
              <span class="text-color-grey text-uppercase font-size-10">
                Applied
              </span>
              <span class="text-medium-black font-size-12">
                In Progress Tickets
              </span>
            </div>
            <div class="inner-card-style ml-2">
              <div class="icon-wrapper icon-bg-all">
                <feather-icon
                  size="24"
                  icon="TagIcon"
                  class="custom-icon-position"
                  stroke="#B9B9C3"
                />
              </div>
              <div class="apply-amount-wrapper">
                <span class="font-size-24">
                  {{ templateDetail.applyAmount.all }}
                </span>
              </div>
              <span class="text-color-grey text-uppercase font-size-10">
                Applied
              </span>
              <span class="font-size-12"> All Tickets </span>
            </div>
          </div>
          <div class="author d-flex flex-wrap mt-2 pr-2 pr-lg-0">
            <div class="last-modified mt-2 mr-sm-3">
              <span
                class="d-block text-medium-black text-uppercase font-size-12"
              >
                Last Modified
              </span>
              <atom-author-avatar
                avatar-variant="light-secondary"
                :author-name="templateDetail.lastModified.actor"
                :author-role="templateDetail.lastModified.role"
                :datetime="templateDetail.lastModified.datetime"
                class="mt-1"
              ></atom-author-avatar>
            </div>
            <div class="created-by mt-2">
              <span
                class="d-block text-medium-black text-uppercase font-size-12"
              >
                Created By
              </span>
              <atom-author-avatar
                avatar-variant="light-secondary"
                :author-name="templateDetail.createdBy.actor"
                :author-role="templateDetail.createdBy.role"
                :datetime="templateDetail.createdBy.datetime"
                class="mt-1"
              ></atom-author-avatar>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mt-3 mt-lg-1">
          <div class="escalation-timeline">
            <span class="text-medium-black font-size-16"
              >Escalation Timeline</span
            >
            <span class="pl-1 font-size-12 text-color-grey">
              (Total {{ escalationTimelineList.length }} Level)
            </span>
            <div class="custom-timeline-height custom-timeline-padding-right">
              <molecule-escalation-timeline
                class="mt-1"
                :escalation-timeline-list="escalationTimelineList"
              ></molecule-escalation-timeline>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-card mt-1">
      <div class="card-topic card-padding">
        <span class="text-semibold-black font-size-12 text-uppercase">
          Impacted ticket
        </span>
      </div>
      <div class="row">
        <div class="col-12">
          <b-table
            sticky-header
            responsive
            hover
            :items="items"
            :fields="fields"
            @row-clicked="selectRow"
            show-empty
          >
            <template #cell(status)="data">
              <div>
                <b-badge
                  pill
                  :variant="tableBadgeVariant(data.item.status)"
                  class="badge--width font-9px"
                >
                  {{ tableBadgeStatus(data.item.status) }}
                </b-badge>
              </div>
            </template>
            <template #cell(issueId)="data"
              ><div class="d-flex">
                <span class="text-medium-black">
                  {{ data.item.issueId.ntdcId }}
                </span>
              </div>
              <div>
                <span class="text-color-grey">
                  {{ data.item.issueId.ticketId }}
                </span>
              </div>
            </template>
            <template #cell(createdDate)="data">
              <div>
                <span>
                  {{ setDateTimeFormat(data.item.createdDate, "dd/MM/yyyy") }}
                </span>
              </div>
              <div>
                <span class="text-regular-grey font-size-12">
                  {{ setDateTimeFormat(data.item.createdDate, "HH:mm:ss") }}
                </span>
              </div>
            </template>
            <template #cell(subject)="data">
              <span class="text-medium-black">{{ data.value }}</span>
            </template>
            <template #cell(detail)="data">
              <div class="custom-detail-wrapper">
                <span class="text-show-new-line">{{ data.value }}</span>
              </div>
            </template>
            <template #empty>
              <div
                class="d-flex flex-column align-items-center justify-content-center my-4"
              >
                <feather-icon
                  icon="CloudOffIcon"
                  class="empty-data__icon"
                ></feather-icon>
                <label class="empty-data__text--title">No Data</label>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="row card-padding">
        <div class="col-6">Showing {{ items.length }} entries</div>
        <div class="col-6 d-flex justify-content-end">
          <b-pagination
            v-model="filterList.pageNumber"
            :total-rows="filterList.totalCount"
            :per-page="10"
            size="sm"
            class="my-0"
            @change="changeCurrentPage"
          ></b-pagination>
        </div>
      </div>
    </div>
    <footer style="padding-top: 21px"></footer>
  </div>
</template>

<script>
import { BBadge, BTable, BPagination } from "bootstrap-vue"
import mixinsDatetime from "@/mixins/mixinsDatetime"

import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomAuthorAvatar from "@/components/atoms/AtomAuthorAvatar.vue"
import MoleculeEscalationTimeline from "@/components/molecules/portal/escalation/MoleculeEscalationTimeline.vue"
import { mapActions, mapGetters } from "vuex"

import mixinsUser from "@/mixins/mixinsUser"
import { PermissionUser } from "@/constants/permission-user"

export default {
  name: "OrganismTemplateDetail",
  components: {
    BBadge,
    BTable,
    BPagination,
    AtomAuthorAvatar,
    AtomButton,
    MoleculeEscalationTimeline,
  },
  mixins: [mixinsDatetime, mixinsUser],
  props: {
    templateDetail: {
      type: Object,
      required: true,
    },
    escalationTimelineList: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    filterList: {
      required: true,
      type: Object,
    },
  },
  emits: ["onChangePage"],
  data() {
    return {}
  },
  computed: {
    ...mapGetters("appFilter", ["getInternalEscalationHistoryFilter"]),

    hasUpdateTicketEscalationPermission() {
      return this.hasPermission(PermissionUser.WPM.TICKET_ESCALATION_WRITE)
    },
    escalationId() {
      return this.$route?.params.escalationTemplateId
    },
  },

  methods: {
    ...mapActions("appFilter", ["setInternalEscalationHistoryFilter"]),
    badgeVariant(status) {
      if (status?.toLowerCase() === "active") return "light-success"
      return "light-secondary"
    },

    badgeStatus(status) {
      if (status?.toLowerCase() === "active") return "Active"
      return "Suspended"
    },

    tableBadgeVariant(status) {
      if (status === "OPENED") return "light-primary"
      if (status === "IN_PROGRESS") return "light-warning"
      return "light-secondary"
    },

    tableBadgeStatus(status) {
      if (status === "OPENED") return "Opened"
      if (status === "IN_PROGRESS") return "In Progress"
      return "Closed"
    },

    changeCurrentPage(page) {
      this.filterList.pageNumber = page
      this.$emit("onChangePage", this.filterList)
    },

    selectRow(row) {
      const { ticketId } = row.issueId
      this.navigateTo(`/internal/web-portal/ticket/${ticketId}`)
    },

    goToTemplateHistory() {
      const filter = {
        ...this.getInternalEscalationHistoryFilter,
        templateName: [
          {
            id: this.escalationId,
            name: this.templateDetail.templateName,
          },
        ],
      }

      this.setInternalEscalationHistoryFilter(filter)
      this.navigateTo("/internal/web-portal/escalation/events")
    },

    navigateTo(path) {
      this.$router.push(path)
    },

    clickEditTemplate(escalationTemplateId) {
      this.navigateTo(
        `/internal/web-portal/escalation/edit/${escalationTemplateId}`
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.card-padding {
  padding: 21px;
}

.card-padding-x {
  padding: 0 21px;
}

.card-padding-y {
  padding: 21px 0;
}

.card-padding-top {
  padding-top: 21px;
}

.card-padding-bottom {
  padding-bottom: 21px;
}

.card-padding-left {
  padding-left: 21px;
}

.card-padding-right {
  padding-right: 21px;
}

.template-detail-card {
  padding: 21px 0 21px 21px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
}
.menu-link {
  padding-top: 3px;
  font-weight: 400;
  font-size: 12px;
  color: #b9b9c3;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
    color: #7367f0;
  }
}

.inner-card-style {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 168px;
  height: 168px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);

  .dot {
    height: 6px;
    width: 6px;
    background-color: #ea5455;
    border-radius: 50%;
    display: inline-block;
    position: absolute;
    top: 0;
    right: -8px;
  }

  .apply-amount-wrapper {
    position: relative;
  }

  .icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
  }

  .custom-icon-position {
    margin: 3px 0 0 3px;
  }

  .icon-bg-in-progress {
    background: rgba(115, 103, 240, 0.12);
  }

  .icon-bg-all {
    background: #f8f8f8;
  }
}

.table-card {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
}

.custom-detail-wrapper {
  width: 245px;
}

.custom-timeline-padding-right {
  padding-right: 21px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  .custom-timeline-height {
    max-height: 610px;
    overflow-y: auto;
  }

  .card-description {
    padding-right: 0;
  }
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
